const MyLodash = {
  forEach: require('lodash/forEach'),
  compact: require('lodash/compact'),
  debounce: require('lodash/debounce'),
  orderBy: require('lodash/orderBy'),
  defaultsDeep: require('lodash/defaultsDeep'),
  includes: require('lodash/includes'),
  random: require('lodash/random'),
  fill: require('lodash/fill'),
  sample: require('lodash/sample')
}
export default MyLodash
